export default __webpack_public_path__ + "static/media/Music_06.bb83adc9.png";